module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./button.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/button.md
// module id = ZI7X
// module chunks = 0